module.exports = __webpack_public_path__ + "img/bac9efe49160497684fc1341256f5c50.a5ca8c79.png";